<app-breadcrumb [links]="[{link: 'admin', name: 'Administração'}]" current="Carousel"></app-breadcrumb>
<div class="backgroundColor shark lighten-1">
  <section class="mb-5 top-119 position-relative">
    <div class="container mb-5">
      <div class="row pt-20 pb-10 d-flex justify-content-center">
        <div class="col-6">
          <h1 class="text-white text-shadow">Inserção de imagens do Slideshow</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-imageInput titulo="Imagens" btn="Ficheiros" [(models)]="media" [multiple]="true" [displayOutput]="false" (modelsChange)="catchEvent($event)"></app-imageInput>
          <div class="row col-12 col-md-6 col-lg-4">
            <ol class="row col-12" cdkDropList (cdkDropListDropped)="drop($event)">
              <li *ngFor="let item of media; let i = index" cdkDrag class="col-12 pointer-grab">
                <div (click)="pop(i)"><fa-icon [icon]="faTimes" class="fad fa-times fa-2x textColor red base position"></fa-icon></div>
                <img [src]="sendUrl(item)" alt="" class="img-fluid pointer-grab" id="{{i}}">
              </li>
            </ol>
          </div>
          <button type="submit" class="btn btn-primary" (click)="sendCarousel()">Submeter</button>
        </div>
      </div>
    </div>
  </section>
</div>
